module.exports = __webpack_public_path__ + "static/media/video-thumbnail.a0b18b1a.png";